export default __webpack_public_path__ + "static/media/alcool-para-menores-proibido.bcf83504.png";